import React, { useContext, useState, useEffect, useRef } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'
import { getMentionList, makeComment } from '../../api/feed';
import { useSelector, useDispatch } from 'react-redux';



export default function CommentInput({ placeholder, postID }) {
    const { isDark } = useContext(DarkModeContext);
    const [Comment, setComment] = useState('');
    const [commentBuilder, setCommentBuilder] = useState(null)
    const commentInputRef = useRef()
    const [mention, setMention] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [mentionedUsers, setMentionedUsers] = useState([]);
    const [lastMention, setLastMention] = useState([]);
    const [initalAtRate, setInitialAtRate] = useState(null)
    const dispatch = useDispatch()

    const commentParentID = useSelector(store => store.commentParentID)
    const commentIndicatorUsername = useSelector(store => store.commentIndicatorName)

    const getAllUsers = async () => {
        const res = await getMentionList();
        setUsers(res);
    }

    useEffect(() => {
        getAllUsers()
    }, [])

    const handleInputChange = async (e) => {
        setComment(e);
        if (e.includes('@')) {
            // if (e.split('@').length == 2) {
            //     if (e.split('@')[0] == ' ') {
            //         console.log(e)
            //         console.log("BITCH!!!")
            //         console.log(commentBuilder, " Builder")
            //         console.log(Comment, " Comment")
            //         setInitialAtRate(e)
            //     }

            // }
            // if (e.split(' ').length == 3) {
            //     if (initalAtRate != null) {
            //         setCommentBuilder(commentBuilder => commentBuilder + initalAtRate)
            //     }
            // }
            if (e.split('@').length > 1) {
                const tempFilteredUsers = users.filter(user => user.data().username.toLowerCase().includes(e.split('@').splice(-1, 1)[0].toLowerCase()));
                setFilteredUsers(tempFilteredUsers);
            } else {
                setFilteredUsers([]);
            }
        } else {
            setFilteredUsers([]);
        }
    }

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const sendAndReset = async (option) => {
        const finalComment = commentIndicatorUsername != null && commentIndicatorUsername != "" ? `<span onClick='window.open("https://lovr.online/user/` + commentIndicatorUsername + `")' ` + `style='color: #CA3443; cursor: pointer'>@${commentIndicatorUsername} </span> ${option == 1 ? Comment : commentBuilder}` : option == 1 ? Comment : commentBuilder
        await makeComment(postID, finalComment, commentParentID, mentionedUsers);

        setComment("")
        setCommentBuilder("")

        commentInputRef.current.value = "";
        dispatch({
            type: 'SET_COMMENT_INDICATOR',
            payload: false
        })
        dispatch({
            type: 'SET_COMMENT_PARENT_ID',
            payload: null
        })
        dispatch({
            type: 'SET_C_I_NAME',
            payload: null
        })
    }

    const sendWithMsgAndReset = async (msg) => {
      //  const finalComment = commentIndicatorUsername != null && commentIndicatorUsername != "" ? `<span onClick='window.open("https://lovr.online/user/` + commentIndicatorUsername + `")' ` + `style='color: #CA3443; cursor: pointer'>@${commentIndicatorUsername} </span> ${option == 1 ? Comment : commentBuilder}` : option == 1 ? Comment : commentBuilder
        await makeComment(postID, msg, commentParentID, mentionedUsers);

        setComment("")
        setCommentBuilder("")
        commentInputRef.current.value = "";
        dispatch({
            type: 'SET_COMMENT_INDICATOR',
            payload: false
        })
        dispatch({
            type: 'SET_COMMENT_PARENT_ID',
            payload: null
        })
        dispatch({
            type: 'SET_C_I_NAME',
            payload: null
        })
    }

    useEffect(() => {
        // console.log(commentBuilder)
    }, [commentBuilder])

    const handleMakeComment = () => {
        // console.log("comment builder: ", commentBuilder)
        var flag = 0;
        if (commentBuilder) {
            if (commentBuilder.trim().length > 0 && commentBuilder != " ") {
                if (commentBuilder.split('@').length == 2 && commentInputRef.current.value.startsWith(' @')) {
                    const x = Comment.split('@')[1].split(' ')[0]
                    const link = `<span onClick='window.open("https://lovr.online/user/` + x + `")' ` + `style='color: #CA3443; cursor: pointer'>@${x} </span>`
                    sendWithMsgAndReset(link + Comment.split('@')[1].split(' ')[1])
                    return;
                }

                const mentionedUserList = commentBuilder.trim().split('@')
                var filteredMentions = mentionedUsers;
                for (var i = 0; i < filteredMentions.length; i++) {
                    for (var j = 0; j < mentionedUserList.length; j++) {
                        if (mentionedUserList[j] != '') {
                            if (!mentionedUserList[j].includes(filteredMentions[i])) {
                                flag = 1;
                            } else {
                                flag = 0;
                                break;
                            }
                        }
                    }
                    if (flag == 1) {
                        filteredMentions.splice(i, 1)
                    }

                }
                setMentionedUsers(filteredMentions)
                sendAndReset(2)
            }
        }
         else {
            if (Comment.trim().length > 0 && Comment != " ") {
                const mentionedUserList = Comment.trim().split('@')
                var filteredMentions = mentionedUsers;
                for (var i = 0; i < filteredMentions.length; i++) {
                    for (var j = 0; j < mentionedUserList.length; j++) {
                        if (mentionedUserList[j] != '') {
                            if (!mentionedUserList[j].includes(filteredMentions[i])) {
                                flag = 1;
                            } else {
                                flag = 0;
                                break;
                            }
                        }
                    }
                    if (flag == 1) {
                        filteredMentions.splice(i, 1)
                    }

                }
                setMentionedUsers(filteredMentions)
                sendAndReset(1)

            }
        }
    }

    const handleKeyPress = async (event) => {
        var flag = 0;
        if (event.key === 'Enter') {
            if (commentBuilder) {
                if (commentBuilder.trim().length > 0 && commentBuilder != " ") {
                    if (commentBuilder.split('@').length == 2 && commentInputRef.current.value.startsWith(' @')) {
                        const x = Comment.split('@')[1].split(' ')[0]
                        const link = `<span onClick='window.open("https://lovr.online/user/` + x + `")' ` + `style='color: #CA3443; cursor: pointer'>@${x} </span>`
                        sendWithMsgAndReset(link + Comment.split('@')[1].split(' ')[1])
                        return;
                    }
                    const mentionedUserList = commentBuilder.trim().split('@')
                    var filteredMentions = mentionedUsers;
                    for (var i = 0; i < filteredMentions.length; i++) {
                        for (var j = 0; j < mentionedUserList.length; j++) {
                            if (mentionedUserList[j] != '') {
                                if (!mentionedUserList[j].includes(filteredMentions[i])) {
                                    flag = 1;
                                } else {
                                    flag = 0;
                                    break;
                                }
                            }
                        }
                        if (flag == 1) {
                            filteredMentions.splice(i, 1)
                        }

                    }
                    setMentionedUsers(filteredMentions)
                    sendAndReset(2);
                }
            } else {
                if (Comment.trim().length > 0 && Comment != " ") {
                    const mentionedUserList = Comment.trim().split('@')
                    var filteredMentions = mentionedUsers;
                    for (var i = 0; i < filteredMentions.length; i++) {
                        for (var j = 0; j < mentionedUserList.length; j++) {
                            if (mentionedUserList[j] != '') {
                                if (!mentionedUserList[j].includes(filteredMentions[i])) {
                                    flag = 1;
                                } else {
                                    flag = 0;
                                    break;
                                }
                            }
                        }
                        if (flag == 1) {
                            filteredMentions.splice(i, 1)
                        }

                    }
                    setMentionedUsers(filteredMentions)
                    sendAndReset(1);
                }
            }
        }
    }

    useEffect(() => {
        // console.log(mentionedUsers)
    }, [mentionedUsers])


    const handleMentionUser = (id, username) => {
        setLastMention(username);
        setMention(mention => [...mention, username]);
        if (commentInputRef.current.value.split('@').length == 2) {

            commentInputRef.current.value = commentInputRef.current.value.split('@')[0].trim() + ' @' + username + ' ';
            const link = `<span onClick='window.open("https://lovr.online/user/` + username + `")' ` + `style='color: #CA3443; cursor: pointer'>@${username} </span>`
            const finalRef = commentInputRef.current.value.replace(commentInputRef.current.value.substring(commentInputRef.current.value.lastIndexOf('@'),
                commentInputRef.current.value.lastIndexOf(username) + username.length).trim(), link);
            // console.log(finalRef, " final ref")
            setCommentBuilder(finalRef)
            if (commentIndicatorUsername != null && commentIndicatorUsername != "") {
                setComment(finalRef)
            }
            commentInputRef.current.focus()

        }
        else if (commentInputRef.current.value.split('@').length > 2) {
            var temp = commentInputRef.current.value.substring(0, commentInputRef.current.value.lastIndexOf('@')).trim() + ' @' + username + ' ';
            var refIndex = commentInputRef.current.value.lastIndexOf('@')
            const link = `<span onClick='window.open("https://lovr.online/user/` + username + `")' ` + `style='color: #CA3443; cursor: pointer'>@${username} </span>`
            const middleText = commentInputRef.current.value.substring(commentInputRef.current.value.lastIndexOf(lastMention) + lastMention.length, commentInputRef.current.value.lastIndexOf('@'));
            const replacedText = commentInputRef.current.value.substring(refIndex, commentInputRef.current.value.length - 1).replace(commentInputRef.current.value.substring(refIndex, commentInputRef.current.value.length - 1), link)
            setCommentBuilder(commentBuilder => commentBuilder + middleText + replacedText)
            commentInputRef.current.value = temp;
            if (commentIndicatorUsername != null && commentIndicatorUsername != "") {
                setComment(commentBuilder)
            }
            commentInputRef.current.focus()
        }

        if (!mentionedUsers.includes(username))
            setMentionedUsers(mentionedUsers => [...mentionedUsers, username])
        setFilteredUsers([]);
    }


    return (
        <div id="commentInput" className={isDark ? 'comment-input-dark' : ''}>
            <div id="commentInputWrapper">
                {filteredUsers.length > 0 && <div className={isDark ? "comment-mention-dark comment-mention-list" : "comment-mention-light comment-mention-list"}>
                    {filteredUsers.map(user => <div onClick={() => handleMentionUser(user.data().id, user.data().username)} className="mention-user-card">
                        <img src={user.data().image} />
                        <div>
                            <h1>{user.data().username}</h1>
                            <p>{user.data().name}</p>
                        </div>


                    </div>)}
                </div>
                }
                <input ref={commentInputRef} onKeyPress={handleKeyPress} onChange={e => handleInputChange(e.target.value)} placeholder={placeholder} />
                <div onClick={handleMakeComment} className={Comment.length != 0 ? 'cm-btn active-comment-button' : 'cm-btn inactive-comment-button'}>
                    <p>POST</p>
                </div>
            </div>
        </div>
    )
}
